import React from 'react'
import { connect } from 'react-redux'
import ProductActions from '../../Redux/ProductRedux'

class ProductVariantDelete extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  _onDelete = () => {
    let data = {
      id: this.props.detail.id,
      product_id: this.props.detail.product_id
    }
    this.props.deleteProductVariant(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 350)
  }

  render () {
    return (
      <section className='section' style={{ width: '40vw' }}>
        <header className='title-block'>
          <h1 className='title'>Delete Dynamic Price</h1>
        </header>
        <div>
          <p className='text-center'>Start Date: <strong>{this.props.detail.start_date}</strong></p>
          <p className='text-center'>End Date: <strong>{this.props.detail.end_date}</strong></p>
        </div>
        <div className='row'>
          <div className='col-12 text-right'>
            <button
              className='btn btn-danger'
              onClick={() => this._onDelete()}
            >
              <i className='fa fa-trash' /> Delete
            </button>
          </div>
        </div>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  product: state.product
})

const dispatchToProps = (dispatch) => ({
  getProductVariant: (data) => dispatch(ProductActions.getProductVariantRequest(data)),
  postProductVariant: (data) => dispatch(ProductActions.postProductVariantRequest(data)),
  putProductVariant: (data) => dispatch(ProductActions.putProductVariantRequest(data)),
  deleteProductVariant: (data) => dispatch(ProductActions.deleteProductVariantRequest(data)),
  getProductVariantItem: (data) => dispatch(ProductActions.getProductVariantItemRequest(data)),
  postProductVariantItem: (data) => dispatch(ProductActions.postProductVariantItemRequest(data)),
  deleteProductVariantItem: (data) => dispatch(ProductActions.deleteProductVariantItemRequest(data))
})

export default connect(stateToProps, dispatchToProps)(ProductVariantDelete)



// WEBPACK FOOTER //
// ./src/Containers/Product/ProductVariantDelete.js